module.exports = __webpack_public_path__ + "static/media/wifi-slash.28b1f6dc.svg";